import * as React from "react";

const style = {
    width: "100%",
    height: "100%",
    display: "flex",
    placeContent: "center",
    placeItems: "center",
};

export function Spinner() {
    return (
        <div style={style}>
            <div className="spinner">
                <div className="bounce1" />
                <div className="bounce2" />
                <div className="bounce3" />
            </div>
        </div>
    );
}

export function AsyncModuleSpinner(props: React.PropsWithChildren<{}>) {
    // maxDuration only works in concurent mode
    // {...{}} magic just to skip typechecking
    return (
        <React.Suspense fallback={<Spinner />} {...{ maxDuration: 1 }}>
            {props.children}
        </React.Suspense>
    );
}
